const authoredSupplyGroup = (product) => String(product?.choice_group || "").trim().startsWith("supply-");

export const patientProductName = (product) => {
  const groupedLabel = authoredSupplyGroup(product)
    ? String(product?.patient_label || "").trim()
    : "";
  if (groupedLabel) return groupedLabel;

  const catalogName = String(
    product?.name
    || product?.product_name
    || product?.label
    || "",
  ).trim();
  if (catalogName) return catalogName;

  const dose = String(
    product?.dose_label
    || product?.dose
    || product?.doseLabel
    || product?.dose_mapping_label
    || "",
  ).trim();
  if (dose) return dose;

  return String(product?.patient_label || product?.category_name || product?.treatment || "").trim();
};
